import { render, staticRenderFns } from "./ProcessSteps.vue?vue&type=template&id=bdc41d5a&scoped=true"
import script from "./ProcessSteps.vue?vue&type=script&lang=js"
export * from "./ProcessSteps.vue?vue&type=script&lang=js"
import style0 from "./ProcessSteps.vue?vue&type=style&index=0&id=bdc41d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc41d5a",
  null
  
)

export default component.exports